import { Entity } from '@nx-smartmonkey/shared/domain';
import { StopTaskStatus } from '../../constants/Stops';
import { RouteStopTaskField, RouteStopTaskFieldDTO } from './StopTaskField';

export interface StopTaskDTO {
  id: string;
  stop_id: string;
  label?: string;
  status: StopTaskStatus;
  fields: RouteStopTaskFieldDTO[];

  // CRUD
  created_at?: Date;
}

export interface StopTaskProps {
  stop_id: string;
  label?: string;
  status: StopTaskStatus;
  fields: RouteStopTaskField[];

  // CRUD
  created_at?: Date;
}

export class StopTask extends Entity<StopTaskProps> {
  get id(): string {
    return this._id!;
  }
  get stop_id(): string {
    return this.props.stop_id;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  set label(label: string | undefined) {
    this.props.label = label;
  }
  get status(): StopTaskStatus {
    return this.props.status;
  }
  set status(status: StopTaskStatus) {
    this.props.status = status;
  }
  get fields(): RouteStopTaskField[] {
    return this.props.fields;
  }
  set fields(fields: RouteStopTaskField[]) {
    this.props.fields = fields;
  }
  get created_at(): Date | undefined {
    return this.props.created_at;
  }

  private constructor(props: StopTaskProps, id: string) {
    super(props, id);
  }

  static create(props: StopTaskProps, id: string) {
    return new StopTask(props, id);
  }
}
